import React, { useContext, useState } from 'react'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import Loading from '../../Common/Loading'
import { TenantsContext } from '../../../context/tenants.context'
import { ITenant } from '../../../pages/AbmLocalPage/types'
import { duplicarLocal } from '../../../pages/Products/services/admin.services'
import DialogDuplicar from './DialogDuplicar'
import DialogResponse, { ResData } from './DialogResponse'

const DuplicarLocal: React.FC<{ codLocal: string }> = ({ codLocal }) => {
  const { tenant } = useContext(TenantsContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [openDuplicar, setOpenDuplicar] = useState<boolean>(false)
  const [openResponse, setOpenResponse] = useState<boolean>(false)
  const [newTenant, setNewTenant] = useState<ITenant>(null)
  const [data, setData] = useState<ResData>(null)

  const handleDuplicar = async () => {
    if (!newTenant || !codLocal) return
    try {
      setLoading(true)
      const res = await duplicarLocal(tenant, codLocal, newTenant)
      setData(res.data.data)
      SnackBarUtils.success('Local duplicado correctamente')
      setOpenResponse(true)
    } catch (e) {
      console.log(e)
      SnackBarUtils.error(e.message === 'Network Error' ? 'Error al duplicar local' : e.message)
    } finally {
      setLoading(false)
      setOpenDuplicar(false)
    }
  }

  if (!codLocal) return <Loading />

  return (
    <>
      <button className="btn btn-success" onClick={() => setOpenDuplicar(true)}>
        Duplicar Local
      </button>
      <DialogDuplicar
        open={openDuplicar}
        setOpen={setOpenDuplicar}
        codLocal={codLocal}
        newTenant={newTenant}
        setNewTenant={setNewTenant}
        handleDuplicar={handleDuplicar}
        loading={loading}
      />
      {data && (
        <DialogResponse
          open={openResponse}
          setOpen={setOpenResponse}
          data={data}
          setData={setData}
          newTenant={newTenant}
          setNewTenant={setNewTenant}
        />
      )}
    </>
  )
}

export default DuplicarLocal
